import { observer } from "mobx-react-lite";

import { ColorSelector } from "@/components/doc/right-sidebar/active-node-style/ColorSelector";
import { ConstantToggler } from "@/components/doc/right-sidebar/active-node-style/fields/ConstantToggler";
import { NodeFieldsBox } from "@/components/doc/right-sidebar/active-node-style/fields/NodeFieldsBox";
import { NodeNameField } from "@/components/doc/right-sidebar/active-node-style/fields/NodeNameField";
import { UnitField } from "@/components/doc/right-sidebar/active-node-style/fields/UnitField";
import { SymbolIndexFields } from "@/components/doc/right-sidebar/active-node-style/symbol/SymbolIndexFields";
import { SymbolValueField } from "@/components/doc/right-sidebar/active-node-style/symbol/SymbolValueField";
import { useNodeTheme } from "@/components/expression/theme";
import { Sidebar } from "@/components/sidebar";

import type { ConstantNodeModel } from "@/models/nodes/ConstantNodeModel";

type Props = {
  node: ConstantNodeModel;
};

export const ConstantStyle = observer(function ConstantStyle({ node }: Props) {
  const { symbolNode } = node;
  const theme = useNodeTheme(node);
  const hasColor = theme?.stroke.type === "colored";

  return (
    <div data-panel="constant_style">
      <div className="px-[5px]">
        <NodeFieldsBox>
          {symbolNode && (
            <SymbolValueField key={node.id} node={node} className="shadow-none dark:shadow-none" />
          )}
          {symbolNode && (
            <SymbolIndexFields
              key={`index-${node.id}`}
              node={symbolNode}
              contextId="label-field"
              className="shadow-none dark:shadow-none"
              withFieldDropdown
            />
          )}
          <NodeNameField node={node} className="shadow-none dark:shadow-none" />
          {node.unitNode && <UnitField node={node} className="shadow-none dark:shadow-none" />}
        </NodeFieldsBox>
        {hasColor && (
          <div className="flex items-center gap-1 my-1">
            <ColorSelector node={node} />
          </div>
        )}
      </div>
      <Sidebar.Delimiter className="my-1.25" />
      <ConstantToggler node={node} />
    </div>
  );
});
